import React from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'

import { SelectFilter } from '../SelectFilter'

interface PlatformTypeFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

const operatingSystemTypes = [
  { name: 'WINDOWS', value: 1 },
  { name: 'OSX', value: 2 },
  { name: 'WEB_TRADER', value: 3 },
  { name: 'ANDROID', value: 4 },
  { name: 'IOS', value: 5 },
  { name: 'ANDROID_APK', value: 6 },
  { name: 'LINUX', value: 7 },
]

export const OperatingSystemFilter: React.FC<PlatformTypeFilterProps> = (props) => {
  const { filter, onFilterChange } = props

  const data = operatingSystemTypes.map((x) => ({ id: x.value, label: x.name, value: x.value }))

  return (
    <SelectFilter
      placeholder='Operating System'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 240 }}
    />
  )
}
